import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";
import {Stack} from "@mui/material";

import Badge from "components/Badge";
import Toggle from "components/Toggle/Toggle";
import {black400, black500, blue500, grey300, greyishBlue200} from "assets/jss/main";

import {targetComparator, targetLabel} from "../enrichmentConstants";

TargetChips.propTypes = {
    targets: PropTypes.objectOf(PropTypes.number).isRequired,
    catalog: PropTypes.object.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

function TargetChips({targets, catalog, value, onChange}) {
    const intl = useIntl();
    const compare = targetComparator(catalog);
    const entries = Object.entries(targets).sort(([a], [b]) => compare(a, b));
    if (0 === entries.length) {
        return null;
    }

    return (
        <Stack direction="row" flexWrap="wrap" gap="12px">
            {entries.map(([target, count]) => {
                const active = target === value;

                return (
                    <Toggle
                        key={target}
                        round
                        noWrapText
                        checked={active}
                        onClick={() => onChange(active ? null : target)}
                        style={{
                            borderRadius: '32px',
                            background: active ? blue500 : '#fff',
                            border: `1px solid ${active ? blue500 : greyishBlue200}`,
                            color: active ? '#fff' : black500,
                        }}
                        label={
                            <span style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}>
                                {targetLabel(intl, catalog, target)}
                                <Badge
                                    backgroundColor={active ? '#fff' : grey300}
                                    labelColor={active ? blue500 : black400}
                                >
                                    {count}
                                </Badge>
                            </span>
                        }
                    />
                );
            })}
        </Stack>
    );
}

export default TargetChips;
